import { render, staticRenderFns } from "./myOrder.vue?vue&type=template&id=3723bd5e&scoped=true&"
import script from "./myOrder.vue?vue&type=script&lang=js&"
export * from "./myOrder.vue?vue&type=script&lang=js&"
import style0 from "./myOrder.vue?vue&type=style&index=0&id=3723bd5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723bd5e",
  null
  
)

export default component.exports